import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class LevelOfMembershipDataService {
  constructor(private httpClient: HttpClient) { }

  // Get All Level of Membership 
  public getAllLevelOfMembership(): Observable<any> {
    return this.httpClient.get('levelOfMembership/getAll').pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  // Get Level of Membership By Id 
  public getLevelDataById(id): Observable<any> {
    return this.httpClient.get('levelOfMembership/getLevelDataById/' + id).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }
}